(function ($) {
  var openSearch = false;

  var navOpen = false;
  var navCloseTimeOut = false;
  var closeMenu = function () {
    // e.preventDefault();
    navOpen = false;
    $("#nav-wrap").removeClass("open");
    $("#subnav-target").html("");
  };

  var prepareClose = function () {
    clearTimeout(navCloseTimeOut);
    navCloseTimeOut = setTimeout(closeMenu, 1000);
  };

  var cancelClose = function () {
    if (navCloseTimeOut) {
      clearTimeout(navCloseTimeOut);
    }
  };
  var showSubmenu = function (e) {
    cancelClose();
    var item = $(this);
    var parent = item.parent();
    parent.addClass("selected");
    var subMenu = $("ul.sub-menu", parent);
    if (!subMenu.length && !parent.hasClass("search-btn")) {
      return true;
    }
    e.preventDefault();
    var subNavHTML = subMenu.html();
    // if (item.hasClass("selected")) {
    //   navOpen = false;
    //   $("#nav-wrap").removeClass("open");
    //   $(this).removeClass("selected");
    //   $("#subnav-target").html("");
    // } else
    if (!navOpen || navOpen !== this.id) {
      navOpen = this.id;
      $("#nav-wrap").addClass("open");
      $("#subnav-target").html(subNavHTML);
      $("a.nav-link").not(this).removeClass("selected");
      $(this).addClass("selected");
    } else {
      $(this).removeClass("selected");
      navOpen = false;
      $("#subnav-target").html("");
    }
  };

  let $returnfocus;
  let $firstFocus;
  var openNav = function () {
    navOpen = true;
    $returnfocus = document.activeElement;
    $("html").addClass("html-open-nav");
    $("body").addClass("open-nav");
    $("#nav").attr("aria-hidden", "false");
    $firstFocus.focus();
  };

  var closeNav = function () {
    navOpen = false;
    $("#nav").attr("aria-hidden", "true");
    $("html").removeClass("html-open-nav");
    $("body").removeClass("open-nav");
    $("li.show-subnav").removeClass("show-subnav");
    $("ul.hidden-level").removeClass("hidden-level");
    $returnfocus.focus();
  };

  var toggleNav = function (e) {
    e.preventDefault();

    if (navOpen) {
      closeNav();
    } else {
      openNav();
    }
  };

  var toggleSubnav = function (e) {
    e.preventDefault();

    var parentItem = $(this).closest(".menu-item-has-children");
    var subMenu = parentItem.find("> ul");
    var hiddenStatus = subMenu.attr("aria-hidden");

    if (hiddenStatus === "false") {
      parentItem.toggleClass("show-subnav");
      parentItem.parent("ul").toggleClass("hidden-level");
      parentItem.find("> a").first().focus();
      setTimeout(function () {
        subMenu.attr("aria-hidden", "true");
      }, 250);
    } else if (hiddenStatus === "true") {
      subMenu.attr("aria-hidden", "false");
      subMenu.find("> a").first().focus();
      setTimeout(function () {
        parentItem.toggleClass("show-subnav");
        parentItem.parent("ul").toggleClass("hidden-level");
      }, 10);
    }
  };
  var delta = 5;
  var lastScrollTop;
  var navbarHeight = 112;
  var overlayHeader = false;
  var checkNavHeight = function () {
    var windowWidth = $(window).width();

    navbarHeight = $(".site-header").outerHeight();
    if ($("main").hasClass("admin-bar")) {
      navbarHeight += windowWidth > 782 ? 0 : 46;
    }

    window.navbarHeight = navbarHeight;

    if (!overlayHeader && !$("body").hasClass("fl-builder-edit")) {
      $("main").css({ paddingTop: 0 });
    } else {
      if (windowWidth < 767) {
        $("main").css({ paddingTop: 0 });
      }
    }
  };
  var hasScrolled = function () {
    var st = $(this).scrollTop();
    var header = $(".site-header");
    var announcement = $(".announcement-wrap");
    // console.log(st);
    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta || navOpen) {
      if (st < 20) {
        header.removeClass("nav-down").removeClass("nav-up");
        announcement.removeClass("nav-down").removeClass("nav-up");
      }
      return;
    }
    var header = $(".site-header");
    var announcement = $(".announcement-wrap");

    // console.log( lastScrollTop );
    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    var topDiff = 0;

    if ($("body").hasClass("fl-builder-edit")) {
      header.removeClass("nav-down").removeClass("nav-up");
      return;
    }
    //  if ( st > lastScrollTop && st > navbarHeight + 100 ) {
    if (st > lastScrollTop && st > topDiff) {
      // Scroll Down
      header.removeClass("nav-down").addClass("nav-up");
      announcement.removeClass("nav-down").addClass("nav-up");
      //filter.css({ 'top': 0 });
    } else {
      // Scroll Up
      if (st === 0 || st < 0) {
        header.removeClass("nav-down").removeClass("nav-up");
        announcement.removeClass("nav-down").removeClass("nav-up");
      } else {
        header.removeClass("nav-up").addClass("nav-down");
        announcement.removeClass("nav-down").addClass("nav-up");
      }
    }

    lastScrollTop = st;
  };

  // var navHover = function(){
  // 	$( '.default-navigation li.menu-item-has-children' ).hoverIntent({
  // 		over: function( ){
  // 			$(this).addClass( 'over' );
  // 		},
  // 		out: function( ){
  // 			$(this).removeClass( 'over' );
  // 		},
  // 		timeout: 100
  // 	});

  // 	$( '.default-navigation li.menu-item-has-children > a' ).on( 'keydown', function( e ){
  // 		// if the key pressed is enter open the sub nav, if the enter key is pressed again, open the link.
  // 		// if the esc key is pressed close the sub nav.
  // 		if ( e.keyCode == 13 && ! $( this ).parent().hasClass( 'over' ) ) {
  // 			e.preventDefault();
  // 			$( this ).parent().addClass( 'over' );
  // 		} else if ( /^Esc(ape)?$/.test(e.key) ) {
  // 			$( this ).parent().removeClass( 'over' );
  // 		}
  // 	});

  // };
  $(document).ready(function () {
    checkNavHeight();
    $(window).on("resize orientationchange", checkNavHeight);
    $(window).on("scroll", hasScrolled);
    $("body").on("fl-builder.endEditingSession", function () {
      setTimeout(function () {
        checkNavHeight(), 250;
      });
    });
    // navHover();

    $(".search-btn a").on("mouseover", function (e) {
      e.preventDefault();
      var searchHTML = $("#search-block").html();
      $("#subnav-target").html(searchHTML);
      openSearch = !openSearch;
    });

    $("#nav-wrap a.nav-link").on("mouseover", showSubmenu);
    $("#nav-wrap").on("mouseout", prepareClose);
    $("#nav-wrap").on("mouseover", cancelClose);

    // $("#close-menu").on("mouseout", closeMenu);

    $firstFocus = $("#mobile-nav").find("a").first();
    document.body.addEventListener(
      "focus",
      function (ev) {
        if (navOpen && !ev.target.closest(".offcanvas-menu")) {
          $firstFocus.focus();
        }
      },
      { capture: true }
    );

    $("a.menu-toggle, a.close-menu").on("click", toggleNav);

    $(
      ".mobile-nav li.menu-item-has-children > a, li.back-btn-wrapper a.back-btn, li.menu-item-has-children a.faux-back-btn"
    ).on("click", toggleSubnav);

    $(".mobile-nav li.menu-item-has-children").each(function () {
      var link = $("> a", this);
      var subList = $("> ul", this);
      var menuId = this.id;
      subList.attr("id", "sub-" + menuId);
      var parentText = link.text();
      subList.find("ul li a span.crumbs").append("/" + parentText);
      link.attr("href", "#sub-" + menuId);
      link.attr("aria-controls", "sub-" + menuId);
      link.prepend("<span class='sr-only'>View more links<span>");
    });
  });
})(jQuery);
